import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Dialog, Grid, Button, TextField, Switch } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import instance from "../../../request/http";
import { BASE_URL } from "../../../store/config";
import { getToday, format2ToTimestamp, timeFormat2, getObjByName2 } from '../../../common/utils';

import UserAutoComplete from '../../Components/UserAutoComplete';
import Toast from "../../Layout/components/Toast";
import { ADD, EDIT } from '../../../common/common';


const Root = styled(Dialog)({
    width: '100%',
    '& .MuiGrid-item': {
        padding: '4px 12px'
    }
})

class LegalFeeEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            isLoaded: false,
            open: false,
            data: {
                date: getToday(),
                handler: null,
                enableAlias: false,
                alias: "MT LAW LLC",
                desc: "",
                handler_name: "",
                rate: 0,
                hours: 0,
                amount: 0,
                isManualRate: true,
            },
            enable: true,
            showToast: false,
            toastMsg: "",
            toastState: "",
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAlias = this.handleAlias.bind(this);
        this.updateHandler = this.updateHandler.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }

    render() {
        const {
            open,
            data,
            showToast,
            toastMsg,
            toastState,
        } = this.state,
            {
                isAdd
            } = this.props,
            showTitle = () => {
                if (isAdd) {
                    return <span>NEW LEGAL FEE</span>
                }
                return <span>EDIT LEGAL FEE</span>
            };

        return <Root open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title" className="editor">
            <DialogTitle id="form-dialog-title">
                <div className="editor-title">{showTitle()}</div>
            </DialogTitle>
            <DialogContent dividers spacing={3}>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            type="date"
                            variant="outlined"
                            label="Date"
                            className="textField"
                            name="date"
                            value={data.date}
                            margin="dense"
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <UserAutoComplete
                            initUser={data.handler}
                            update={this.updateHandler}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            value="start"
                            control={
                                <Switch
                                    checked={data.enableAlias}
                                    onChange={e => this.handleAlias(e)}
                                    color="primary"
                                />
                            }
                            label="Enable alias name"
                            labelPlacement="start"
                            style={{ marginTop: '8px' }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled={!data.enableAlias}
                            variant="outlined"
                            margin="dense"
                            name="alias"
                            value={data.alias}
                            label="Alias name"
                            type="text"
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            label="Description"
                            type="text"
                            name="desc"
                            value={data.desc}
                            multiline
                            rows="4"
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            label="Hours"
                            type="number"
                            name="hours"
                            value={data.hours}
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            label="Rate"
                            type="number"
                            name="rate"
                            value={data.rate}
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            label="Amount"
                            type="number"
                            name="amount"
                            value={data.amount}
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => this.handleClose()}>
                    Cancel
                </Button>
                <Button onClick={() => this.handleClose(isAdd ? ADD : EDIT)} variant="contained" color="primary">
                    Save
                </Button>
            </DialogActions>
            <Toast
                open={showToast}
                msg={toastMsg}
                state={toastState}
                handleClose={this.handleCloseToast}
            ></Toast>
        </Root>

    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        const {
            open,
            itemId: id,
            item,
        } = this.props;
        if (prevProps.open !== open) {
            if (open) {
                this.initEditor(id, item);
            } else {
                this.setState({
                    open
                });
            }
        }
    }

    handleClose(status) {
        const { onClose, invoiceId } = this.props;
        if (typeof onClose !== 'function') {
            console.error("onClose is not a function");
            return
        }

        if (status !== null && status !== undefined) {
            const { data, rate } = this.state;
            if (!data.handler) {
                this.showToast("Please choose a user!", "error");
                return;
            }

            const params = {
                rate: data.rate,
                hours: data.hours,
                amount: data.amount,
                date: format2ToTimestamp(data.date),
                description: data.desc,
                alias: data.alias,
                enable_alias: data.enableAlias,
                handler_id: data.handler.id,
                is_manual_rate: data.isManualRate,
                type: 'Legal Fee',
            };
            if (status === ADD) {
                this.addLegalFee(params, (legal_fee_id) => {
                    onClose(ADD, legal_fee_id);
                });
            } else {
                this.saveLegalFee(data.id, params, () => {
                    onClose(EDIT);
                });
            }
        } else {
            onClose();
        }
    }

    initEditor(id, item) {
        // this.getLegalFee(id);
        console.log("legalData", this.props.legalData)
        // console.log(item);
        const {
            isAdd,
        } = this.props;
        this.setState({
            open: true,
            data: {
                date: isAdd ? getToday() : timeFormat2(item.date),
                desc: isAdd ? "" : item.description,
                alias: isAdd ? "MT LAW LLC" : item.alias || "MT LAW LLC",
                enableAlias: isAdd ? false : item.enable_alias || false,
                handler: isAdd ? null : item.handler,
                handler_name: isAdd ? "" : item.handler_name,
                rate: isAdd ? 0 : item.rate || 0,
                hours: isAdd ? 0 : item.hours || 0,
                amount: isAdd ? 0 : item.amount || 0,
                id: isAdd ? -1 : item.id,
                isManualRate: isAdd ? true : item.is_manual_rate,
                timesheet: isAdd ? null : item.timesheet,
            }
        });
    }

    handleChange(e) {
        const { value, name } = e.target;
        console.log(value, name);

        if (name === "hours") {
            const { rate } = this.state.data,
                amount = value * rate;
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    hours: value,
                    amount: amount.toFixed(2),
                }
            }));
            return;
        }

        if (name === "rate") {
            const { hours } = this.state.data,
                amount = value * hours;
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    rate: value,
                    amount: amount.toFixed(2)
                }
            }));
            return;
        }

        if (name === "amount") {
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    hours: 0,
                    rate: 0,
                    amount: value,
                }
            }));
            return;
        }

        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                [name]: value
            }
        }));
    }

    handleAlias(event) {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                enableAlias: isChecked,
            }
        }));
    }

    updateHandler(handler) {
        if (!handler) return;
        this.extractRate(handler,(rate)=>{
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    handler: handler,
                    rate,
                }
            }));
        });
    }
    extractRate(obj,callback) {
        const { legalData, invoiceId } = this.props;
        const userId = obj.id;
        // const findObj = getObjByName2(legalData, "handler", "id", id);
        this.getInvoiceRate(invoiceId, userId, (rate) => {
            console.log("user的rate", rate ? rate : obj.rate)
            const userRate = rate ? rate : obj.rate;
            if(callback)callback(userRate);
        })
        // if (findObj) {
        //     return findObj.rate;
        // } else {
        //     return obj.rate;
        // }
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }


    // todo: this api doesn't exist
    getLegalFee(id) {
        instance.get(BASE_URL + 'billing/legal_fee/' + id, {}).then((res) => {
            console.log(res);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    addLegalFee(params, callback) {
        instance.post(BASE_URL + 'billing/legal_fee', params).then((res) => {
            console.log(res.data.data.id);
            const legal_fee_id = res.data.data.id;
            callback(legal_fee_id);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    saveLegalFee(id, params, callback) {
        instance.put(BASE_URL + 'billing/legal_fee/' + id, params).then((res) => {
            // this.showToast("Successfully modified", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        });
    }
    getInvoiceRate(invoice_id, user_id, callback) {
        instance.get(BASE_URL + `billing/invoices/${invoice_id}/users/${user_id}/rate`).then((res) => {
            const rateArr = res.data.data;
            let rate = null;
            if (rateArr.length > 0) {
                rate = rateArr[0].rate;
            }
            if (callback) callback(rate);
        })
    }
}

export default LegalFeeEditor;